import { PAYMENT_METHODS } from 'settings/constants/payment'

const { CREDIT_CARD, ACH } = PAYMENT_METHODS

export const getIsCreditCard = paymentMethod => paymentMethod === CREDIT_CARD

export const getIsACH = paymentMethod => paymentMethod === ACH
